class GoogleMapListing {
	constructor() {
		this.container = document.querySelector(".google-map-listing");
		if (this.container) {
			resizeCallbacks.push(this);
			this.buildTheMap();
		}

	}

	buildTheMap() {

		if (this.container) {
			const theMap = this.container.querySelector(".google-map");
			const markers = this.container.querySelectorAll(".google-map-markers .item");
			const customZoom = this.container.querySelector(".custom-zoom");
			this.cardsContainer = document.querySelector(".listing-nursery");
			this.cards = document.querySelectorAll(".listing-nursery-card");

			if (theMap) {
				this.bounds = new google.maps.LatLngBounds();
				this.markersResults = [];

				this.infowindow = new google.maps.InfoWindow();
				this.map = new google.maps.Map(theMap, {
					center: {lat: 45.619722, lng: 4.6730292},
					zoom: 11,
					maxZoom: 18,
					disableDefaultUI: true,
					styles: googleMapStyle
				});

				markers.forEach(marker => {
					let markerID = marker.dataset.id;
					let name = marker.dataset.name;
					let address = marker.dataset.streetaddress;
					let thumbnail = marker.dataset.thumbnail;
					let url = marker.dataset.url;
					let lat = marker.dataset.lat;
					let lng = marker.dataset.lng;
					let markerPointer = marker.dataset.pointer;
					let project = marker.dataset.project;

					if (lat && lng) {
						marker = new google.maps.Marker({
							marker_id: markerID,
							position: {
								lat: parseFloat(lat),
								lng: parseFloat(lng)
							},
							map: this.map,
							icon: mapHelper.googleMapIcon(markerPointer, project)
						});

						marker.addListener('click', () => {
							this.infowindow.close();
							this.infowindow.setContent(`
								<div class="map-infowindow">
									<div class="map-infowindow-image">
										<img src="${thumbnail}" alt="${name}">
									</div>
									<div class="map-infowindow-meta">
										<a href="${url}" class="map-infowindow-name">${name}</a>
										<div class="map-infowindow-address">${address}</div>
									</div>									
								</div>`);
							this.infowindow.open(this.map, marker);
							this.map.panTo(marker.getPosition());
						});

						this.markersResults[markerID] = marker;
						this.markersResults[markerID].opacity = 1;
						this.bounds.extend(marker.getPosition());
					}
				});

				this.map.fitBounds(this.bounds);
				this.customZoom(customZoom, this.map);
				if (this.cardsContainer) {
					this.cardHoverAction();
				}
			}
		}
	}

	cardHoverAction() {
		if (this.cards) {
			let that = this;

			this.cards.forEach(card => {
				let currentMarker = card.dataset.id;
				card.addEventListener('mouseover', () => {
					// this.highlightCurrent(currentMarker);
					this.toggleBounce(currentMarker, 'on');
					// setTimeout(function () {
					// 	that.toggleBounce(currentMarker, 'off');
					// }, 700); // current maps duration of one bounce (v3.13)
				});

				card.addEventListener('mouseleave', () => {
					// this.highlightCurrent(currentMarker);
					this.toggleBounce(currentMarker, 'off');
					// setTimeout(function () {
					// 	that.toggleBounce(currentMarker, 'off');
					// }, 700); // current maps duration of one bounce (v3.13)
				});


			});

			// this.cardsContainer.addEventListener('mouseleave', () => {
			// 	this.toggleBounce(currentMarker, 'off');
			// });
		}
	}

	toggleBounce(marker_id, state) {
		for (var i in this.markersResults) {
			if (this.markersResults[i].marker_id === marker_id) {
				if (state === 'on') {
					this.markersResults[i].setAnimation(google.maps.Animation.BOUNCE);
				} else {
					this.markersResults[i].setAnimation(null);
				}
			}
		}
	}

	// highlightCurrent(marker_id) {
	// 	for (const item in this.markersResults) {
	// 		const currentItem = this.markersResults[item];
	// 		if (currentItem.marker_id === marker_id) {
	// 			gsap.to(currentItem, {
	// 				opacity: 1,
	// 				duration: 0.3,
	// 				onUpdate: e => {
	// 					currentItem.setOpacity(currentItem.opacity);
	// 				}
	// 			});
	// 		} else {
	// 			gsap.to(currentItem, {
	// 				opacity: 0.3,
	// 				duration: 0.3,
	// 				onUpdate: e => {
	// 					currentItem.setOpacity(currentItem.opacity);
	//
	// 				}
	// 			});
	// 		}
	// 	}
	// }
	//
	// restoreOpacity() {
	// 	for (const item in this.markersResults) {
	// 		const currentItem = this.markersResults[item];
	// 		gsap.to(currentItem, {
	// 			opacity: 1,
	// 			duration: 0.3,
	// 			onUpdate: e => {
	// 				currentItem.setOpacity(currentItem.opacity);
	// 			}
	// 		});
	// 	}
	// }

	customZoom(controlDiv, map) {
		google.maps.event.addDomListener(zoomout, 'click', function () {
			var currentZoomLevel = map.getZoom();
			if (currentZoomLevel != 0) {
				map.setZoom(currentZoomLevel - 1);
			}
		});

		google.maps.event.addDomListener(zoomin, 'click', function () {
			var currentZoomLevel = map.getZoom();
			if (currentZoomLevel != 21) {
				map.setZoom(currentZoomLevel + 1);
			}
		});
	}

	resize() {
		this.map.fitBounds(this.bounds);
	}
}